// Collapses HTML (e.g. a rendered notification template) down to plain text — the one shared
// copy of this logic; every render site that needs a text-only preview of (or text-only search
// match against) HTML content imports this rather than re-implementing tag-stripping locally.
// Never used as a sanitize-for-render step — the result is only ever set as plain text
// (`children`, not `dangerouslySetInnerHTML`), so it doesn't need DOMPurify.
//
// Extracted verbatim from EditTemplateDialog.tsx's original plainTextFromHtml — converts
// <br>/block-closing tags to newlines first (so e.g. "Hi {{recipientName}},</p><h2>{{title}}</h2>"
// doesn't collapse into one run-on line with no space between them), decodes the handful of
// entities renderTemplateWithVariables() escapes into (see notification-email.template.ts), and
// collapses runs of blank lines down to at most one.
export function htmlToPlainText(html: string): string {
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6])>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/[ \t]+/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
